// extracted by mini-css-extract-plugin
export default {"root":"StarsPoll__root___MFAYS","item":"StarsPoll__item___jlHTv","itemIcon":"StarsPoll__itemIcon___qL0o_","itemIconActive":"StarsPoll__itemIconActive___GsJSz"};